import React from 'react'
import { 
    CellsTitle, Cells, TextArea, CellBody, Form, FormCell, Button,
    Toast, Dialog, Toptips, Select, CellFooter, Switch
} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import { browserHistory } from 'react-router'
import Header from '../../components/liveroomLecturer/Header'
import { getAccessToken } from '../../utils'
import '../../css/page/ChannelLectureEditPage.css'
import Config from '../../config'

const ADMIN_URL =
  '139.199.89.56' === location.hostname ||
  'dbg.weike.fm' === location.hostname ||
  'dbg.lizhiweike.com' === location.hostname ||
  'localhost' === location.hostname
    ? 'http://dev.admin.lizhiweike.com'
    : 'https://admin.lizhiweike.com'

class LectureEditChannelPage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            channels: [],
            channelId: 0,
            isShowAtLiveroom: false,
            lecture: null,
            jwt_token: null,
            isShowNoMatchDialog: false,
            alertDialog: {
                isShow: false,
                text: '',
            },
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
        }
    }
    async componentDidMount () {
        const { data: { code, access_token } } = await axios.create({
            baseURL: Config.AUTH_URL
          }).get(
            `/oauth2/access_token?client_id=${Config.CLIENT_ID}&grant_type=cookie`,
            { 
                withCredentials: true
            }
        )
        if(code === 0) {
            this.setState({
               jwt_token: access_token
            })
            this.fetchData()   
        }
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    fetchData () {
        this.setState({ isPending: true })
        axios.get(`/api/lecture/${this.props.params.id}/edit_info`)
            .then(res => {
                this.setState({ 
                    lecture: res.data.data.lecture,
                    channels: res.data.data.channels || [], 
                    isShowAtLiveroom: res.data.data.lecture.show_in_liveroom_list,
                    channelId: res.data.data.lecture.channel_id || 0,
                    isPending: false,
                })
            })
    }
    showAlert (text) {
        this.setState({
            alertDialog: { isShow: true, text }
        })
    }
    onClickAlertOk () {
        browserHistory.go(-1)
    }
    bindValue (e, field) {
        const value = e.target.value
        if (field === 'channelId') {
            if (this.state.lecture.lecture_type === 'pay_channel') {
                if (+value === 0 || this.state.channels.find(item => item.id == value).need_money === false) {
                    this.setState({ isShowNoMatchDialog: true })
                    return
                }
            }
        }
        this.setState({ [field]: value })
    }
    async onSubmit (e) {
        this.setState({ isPending: true })
        const { liveroom_id } = this.props.location.query
        const lecture_id = this.props.params.id
        const channel_id = this.state.channelId
        const is_show_in_liveroom = this.state.isShowAtLiveroom
        const token = this.state.jwt_token
        const { data } = await window.axiosAdmin.get(`/api/liverooms/${liveroom_id}/lectures/${
            lecture_id
          }/move_to_channel/${
            channel_id
          }?show_in_liveroom_list=${is_show_in_liveroom}`, {
            params: { token },
            baseURL: ADMIN_URL
          }
        )
        this.setState({ isPending: false })
        if (data.code !== 0) {
          return this.showTip(data.msg)
        }
        this.showAlert('修改成功')
        // axios.post(`/api/lecture/${this.props.params.id}/edit`, qs.stringify({
        //     channel: this.state.channelId,
        //     show_in_liveroom_list: this.state.isShowAtLiveroom,
        // }))
        //     .then(res => {
        //         this.setState({ isPending: false })
        //         if (res.data.code !== 0) {
        //             return this.showTip(res.data.msg)
        //         }
        //         this.showAlert('修改成功')
        //     })
    }
    render() {
        return (
            <div className='page'>
                <div className="wk-inner-page channel-lecture-edit-page">
                    <div className="lecture-channel-page">
                        <Header title='所属专栏' />
                        <Form className='margin-bottom'>
                            <FormCell select>
                                <CellBody>
                                    <Select onChange={e => this.bindValue(e, 'channelId')} value={this.state.channelId}>
                                        <option value={0}>无</option>
                                        {
                                            this.state.channels.map(item => (
                                                <option key={item.id} value={item.id}>
                                                    {item.name}（{item.need_money ? '付费专栏' : '免费专栏'}）
                                                </option>
                                            ))
                                        }
                                    </Select>
                                </CellBody>
                            </FormCell>
                            <FormCell switch>
                                <CellBody>在直播间显示</CellBody>
                                <CellFooter>
                                    <Switch 
                                        checked={this.state.isShowAtLiveroom}
                                        onChange={e => this.setState({ isShowAtLiveroom: e.target.checked })}
                                    />
                                </CellFooter>
                            </FormCell>
                        </Form>
                        <div className="wk-btn-90 padding-top-10">
                            <Button onClick={e => this.onSubmit()}>保存</Button>
                        </div>
                    </div>
                </div>
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Dialog type="ios" title='' buttons={[
                    { label: '确定', onClick: () => this.onClickAlertOk() }
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
                {/* 选择不匹配的专栏提示 */}
                <Dialog type="ios" title='' buttons={[
                    { label: '确定', onClick: () => this.setState({ isShowNoMatchDialog: false }) }
                ]} show={this.state.isShowNoMatchDialog}>
                    类型为“必须购买专栏”的课程不可移出付费专栏，若需修改，请先到“课程编辑 - 加密与付费”，修改课程类型
                </Dialog>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
            </div>
        )
    }
}


export default LectureEditChannelPage


// WEBPACK FOOTER //
// ./src/pages/LectureEdit/LectureEditChannelPage.js